import axios from 'axios';

import { MemberSummary, ListResponseWithTotalCount, ApiConfig, Member, PartialUpdateEntity, UserKey } from '../types';
import { toSerializedError } from '../errors/utils';

export type ListMembersResponse = ListResponseWithTotalCount<MemberSummary>;
export type ListMembersParams = {
  tenant_id: string;
  page: number;
  pre_page: number;
};

export async function listMembers({ api_url, headers }: ApiConfig, { tenant_id, ...params }: ListMembersParams) {
  try {
    let res = await axios.get<ListMembersResponse>(api_url+'/api/users/me/tenants/'+tenant_id+'/users', {
      headers,
      params,
    });
    return res.data;
  } catch(err) {
    throw toSerializedError(err);
  }
}

export type CreateMemberParams = {
  tenant_id: string;
  body: Pick<Member, 'name'|'username'|'description'|'state'> & { password?: string };
};
export type CreateMemberResponse = {
  id: string;
  request_id: string;
};

export async function createMember(
  { api_url, headers }: ApiConfig,
  { tenant_id, body }: CreateMemberParams,
) {
  try {
    let res = await axios.post<CreateMemberResponse>(api_url+'/api/users/me/tenants/'+tenant_id+'/users', body, {
      headers,
    });
    return res.data;
  } catch(err) {
    throw toSerializedError(err);
  }
}

export type GetMemberParams = {
  tenant_id: string;
  user_id: string;
};
export type GetMemberResponse = Member;

export async function getMember(
  { api_url, headers }: ApiConfig,
  { tenant_id, user_id }: GetMemberParams,
) {
  try {
    let res = await axios.get<GetMemberResponse>(api_url+'/api/users/me/tenants/'+tenant_id+'/users/'+user_id, {
      headers,
    });
    return res.data;
  } catch(err) {
    throw toSerializedError(err);
  }
}

export type UpdateMemberParams = {
  tenant_id: string;
  user_id: string;
  body: PartialUpdateEntity<Pick<Member, 'name'|'username'|'description'|'state'>> & {
    password?: null|string;
  };
};
export type UpdateMemberResponse = {
  password?: string;
  request_id: string;
};

export async function updateMember(
  { api_url, headers }: ApiConfig,
  { tenant_id, user_id, body }: UpdateMemberParams,
) {
  try {
    let res = await axios.patch<UpdateMemberResponse>(api_url+'/api/users/me/tenants/'+tenant_id+'/users/'+user_id, body, {
      headers,
    });
    return res.data;
  } catch(err) {
    throw toSerializedError(err);
  }
}

export type DeleteMemberParams = {
  tenant_id: string;
  user_id: string;
};
export type DeleteMemberResponse = {
  request_id: string;
};

export async function deleteMember(
  { api_url, headers }: ApiConfig,
  { tenant_id, user_id }: DeleteMemberParams,
) {
  try {
    let res = await axios.delete<DeleteMemberResponse>(api_url+'/api/users/me/tenants/'+tenant_id+'/users/'+user_id, {
      headers,
    });
    return res.data;
  } catch(err) {
    throw toSerializedError(err);
  }
}

export type CreateUserKeyParams = {
  tenant_id: string;
  user_id: string;
  body: Pick<UserKey, 'description'>;
};

export type CreateUserKeyResponse = {
  request_id: string;
  type: string;
  tenant_id: string;
  private_key_id: string;
  private_key: string;
  user_id: string;
};

export async function createUserKey(
  { api_url, headers }: ApiConfig,
  { tenant_id, user_id, body }: CreateUserKeyParams,
) {
  try {
    let res = await axios.post<CreateUserKeyResponse>(api_url+'/api/users/me/tenants/'+tenant_id+'/users/'+user_id+'/keys', body, {
      headers,
    });
    return res.data;
  } catch(err) {
    throw toSerializedError(err);
  }
}

export type DeleteUserKeyParams = {
  tenant_id: string;
  user_id: string;
  key_id: string;
};
export type DeleteUserKeyResponse = {
  request_id: string;
};

export async function deleteUserKey(
  { api_url, headers }: ApiConfig,
  { tenant_id, user_id, key_id }: DeleteUserKeyParams,
) {
  try {
    let res = await axios.delete<DeleteMemberResponse>(api_url+'/api/users/me/tenants/'+tenant_id+'/users/'+user_id+'/keys/'+key_id, {
      headers,
    });
    return res.data;
  } catch(err) {
    throw toSerializedError(err);
  }
}
